// extracted by mini-css-extract-plugin
export default {"nav":"Hedaer_nav__U9L+i"};